// src/helpers/notifications/templates/updates.ts
import { TemplateMeta } from '../notificationConfig';
import { formatReadableDate } from 'helpers/date';

export const updatesManualTemplates: TemplateMeta[] = [
    {
        key: 'profile.updated',
        label: 'Profile Updated',
        type: 'updates',
        icon: 'ri-user-settings-line text-secondary',
        title: () => `Your profile was updated`,
        subtitle: d => `Changes: ${d.fields_changed}`,
    },
    {
        key: 'password.changed',
        label: 'Password Changed',
        type: 'updates',
        icon: 'ri-lock-password-line text-danger',
        title: () => `Your password was changed`,
        subtitle: () => `Ensure it’s secure`,
    },
    {
        key: 'subscription.renewed',
        label: 'Subscription Renewed',
        type: 'updates',
        icon: 'ri-vip-crown-line text-warning',
        title: () => `Subscription renewed`,
        subtitle: d => `Valid through ${formatReadableDate(d.expiry_date)}`,
    },
    {
        key: 'feature.available',
        label: 'New Feature Available',
        type: 'updates',
        icon: 'ri-rocket-line text-success',
        title: d => `New feature available: ${d.feature_name}`,
    },
];
